import { render } from "./SectionsView.vue?vue&type=template&id=12be3fc6"
import script from "./SectionsView.vue?vue&type=script&lang=js"
export * from "./SectionsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__